module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable"],"commonjs":"rxjs/observable/combineLatest","commonjs2":"rxjs/observable/combineLatest","amd":"rxjs/observable/combineLatest"}
// module id = 22
// module chunks = 0 1